<template>
  <div class="mianDiv">
    <img src="./img/empty_2.png" alt="" />
    <div class="text">系统繁忙,请稍后再试~</div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
  created() {}
};
</script>
<style lang="less" scoped>
.mianDiv {
  // height: 100%;
  // width: 100%;
  // overflow: auto;
  // background-color: #fff;
  text-align: center;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // flex-flow: column;
  & > .text {
    color: #999;
    font-size: 17px;
  }
}
</style>
